import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function SiteLayout() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className="wood-grain flex min-h-screen w-full flex-col">
      <Navbar />
      <main className={`flex-1 ${isHome ? "" : "pt-[72px]"}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}